<template>
  <div class="product_list_bag">
    <div class="common_menu">
      <el-row>
        <el-col :span="4">
          <div>&nbsp;</div>
        </el-col>
        <el-col :span="4" v-for="(item,index) in allProArr" :key="index">
          <div class="menu_item" :class="{ active_menu:activeIndex==index }" @click="filtProduct(index)">{{item.name}}</div>
        </el-col>
        <el-col :span="4">
          <div>&nbsp;</div>
        </el-col>
      </el-row>
    </div>
    <div class="product_cup">
      <div class="product-list-cup">
        <el-row :gutter="30" class="productRow">
          <el-col :span="6" v-for="(itemP,index) in productList" :key="index">
            <el-card class="cardStyle">
              <img :src="itemP.productImg" class="image" width="95%" height="240">
              <div class="pro-summary">
                <p>{{itemP.productName}}</p>
                <div class="color2">{{itemP.companyName}}</div>
              </div>
              <el-button type="primary" @click="viewProductInfo(itemP.productId)">详细信息&nbsp;&nbsp;<span class="el-icon-right"></span></el-button>
            </el-card>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>
<script>
import { viewProductInfo } from '@/api/frontApi/frontProduct';
export default {
  data() {
    return {
      allProArr: [
        { name: '全部产品' },
        { name: '机械产品' },
        { name: '软件产品' },
        { name: '备件产品' }
      ],
      activeIndex: 0,
      pageNo: 1,
      pageSize: 10,
      totalPage: 1,
      productList: [],
      whichProduct: []
    };
  },
  computed: {
    defaultImg() {
      return this.$store.state.defaultImg;
    }
  },
  created() {
    this.initProductsData();
  },
  methods: {
    initProductsData(productType) {
      viewProductInfo({
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        recommend: 1,
        productTypeId: productType
      }).then(res => {
        res.data.list.forEach(item => {
          if (!item.productImg) {
            item.productImg = this.defaultImg;
          }
        });
        this.productList = res.data.list;
      });
    },
    productSelect(key) {
      this.whichProduct = [];
      switch (parseInt(key)) {
        case 1:
          for (let s = 0; s < this.productList.length; s++) {
            if (this.productList[s].orgType === 1) {
              this.whichProduct.push(this.productList[s]);
            } else {
              continue;
            }
          }
          break;
        case 2:
          for (let s = 0; s < this.productList.length; s++) {
            if (this.productList[s].orgType === 2) {
              this.whichProduct.push(this.productList[s]);
            } else {
              continue;
            }
          }
          break;
        case 3:
          for (let s = 0; s < this.productList.length; s++) {
            if (this.productList[s].orgType === 3) {
              this.whichProduct.push(this.productList[s]);
            } else {
              continue;
            }
          }
          break;
      }
    },
    viewProductInfo(proId) {
      let hProductRoute = this.$router.resolve({
        name: 'productInfo',
        query: parseInt(proId),
        params: {
          productId: parseInt(proId)
        }
      });
      window.open(hProductRoute.href, '_blank');
    },
    filtProduct(index) {
      this.activeIndex = index;
      this.productSelect(index);
    }
  }
};
</script>
<style scoped>
.product_list_bag {
  width: 100%;
  min-height: 600px;
  text-align: center;
  background-color: #fff;
}
.product_cup {
  width: 76%;
  margin: 0 auto;
}
.common_menu {
  width: 100%;
  height: 62px;
  line-height: 62px;
  background-color: #e6e6e6;
}
.menu_item {
  width: 100%;
  height: 100%;
  font-size: 19px;
  color: #717171;
}
.menu_item:hover {
  cursor: pointer;
}
.active_menu {
  color: #fff;
  background-color: #093977;
}
.product-list-cup {
  width: 100%;
  /* padding: 20px 12% 30px; */
  text-align: center;
  padding: 10px 0;
  min-width: 969px;
}
.productRow {
  margin-bottom: 30px;
}
.cardStyle {
  text-align: center;
  margin-bottom: 30px;
  min-height: 430px;
}
.color1 {
  color: #f56c6c;
}
.color2 {
  color: #409eff;
}
.color3 {
  color: #67c23a;
}
.color4 {
  /* color: #909399; */
  color: #e6a23c;
}
.proInfoLink {
  padding: 12px 18px;
  color: #fff;
  background-color: #409eff;
  border-radius: 5px;
}
.proInfoLink:hover {
  padding: 12px 18px;
  color: #409eff;
  background-color: #fff;
  border-radius: 5px;
  border: 1px solid #409eff;
}
.pro-summary {
  text-align: center;
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/views/product/productBody.vue